/**
 * @module ol/ViewHint
 */

/**
 * @enum {number}
 */
export default {
  ANIMATING: 0,
  INTERACTING: 1
};

//# sourceMappingURL=ViewHint.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/ViewHint.js
// module id = 13
// module chunks = 0